module.exports = __webpack_public_path__ + "media/src/images/logo_iversity_springer-ecb664de570fe964e55911361a0c7cfa.svg";